@switch (layout()) {
  @case (Layout.Grid) {
    <lib-feature-kpi-grid
      [topPerspective]="topPerspective()"
      [reportPath]="reportPath()"
      [tileViewPage]="tileViewPage()"
    />
  }
  @case (Layout.List) {
    <lib-feature-kpi-list
      [topPerspective]="topPerspective()"
      [reportPath]="reportPath()"
      [tileViewPage]="tileViewPage()"
    />
  }
}
